import React, { useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import DashboardSpecial from '../DashboardSpecial/DashboardSpecial';



const DashboardSpecials = () => {
    const [specials, setSpecials] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetch('https://gentle-tor-99938.herokuapp.com/specials')
            .then(res => res.json())
            .then(async (data) => await setSpecials(data))
            .finally(() => setIsLoading(false));

    }, [])


    return (
        <div>
            {
                isLoading
                    ?
                    <div className="spinner d-flex align-items-center justify-content-center">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                    </div>
                    :

                    <Row xs={1} md={2} className="g-4 my-5 specials">
                        {
                            specials.map(special => <DashboardSpecial
                                special={special}
                            />)
                        }
                    </Row>
            }
        </div>
    );
};

export default DashboardSpecials;